module.exports = __webpack_public_path__ + "img/cate6.e1b4b74b.png";